<template>
    <md-button class="md-primary md-just-icon md-round" @click="showUpdateIssueDialog" title="Edit Issue">
        <md-icon>edit</md-icon>
    </md-button>
</template>

<script>
export default {
    name: 'UpdateIssueButton',
    props: {
        issue: {
            type: [Number, Object],
            required: true
        }
    },
    data() {
        return {
            issueId: null
        };
    },
    created() {
        this.issueId = typeof this.issue === 'object' ? this.issue.issueId : this.issue;
    },
    methods: {
        showUpdateIssueDialog() {
            this.$modal
                .show({
                    class: 'md-modal-container',
                    title: 'Edit Issue',
                    body: 'This would open an edit form for the issue.',
                    buttons: ['OK', 'Cancel']
                })
                .then((response) => {
                    if (response.toLowerCase() === 'ok') {
                        this.$emit('issueUpdated', response);
                    }
                });
        }
    }
};
</script>
